import { defineComponent as _defineComponent } from 'vue'
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { computed } from 'vue';
import { normalizeTrailingSlash } from 'JS/utilities/url';
import { TileGridWidgetImageTile } from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridWidgetImageTile',
  props: {
    tile: null,
    promoAttrs: null
  },
  setup(__props: any) {

const props = __props as {
	tile: TileGridWidgetImageTile;
	promoAttrs: AnalyticsPromoAttrs;
}



const normalizedLink = computed(() => {
	return normalizeTrailingSlash(props.tile.linkUrl);
});


return { __sfc: true,props, normalizedLink }
}

})